import React, {useEffect, useState} from "react";
import {firestore} from "../../firebase/clientApp";
import {Box, Container, Stack, Typography, useTheme} from "@mui/material";
import {Textfit} from "react-textfit";
import {QuestionSwitch} from "./QuestionSwitch";
import pleshDark from "../../theme/pleshDark";
import useLanguageStore from "../../store/languageStore";
import {getTranslatedText} from "../../functions/getTranslatedText";

function QuestionBar({tipo, domanda, domandaTranslations, domandaDescription, domandaDescriptionTranslations, colore}) {
  const theme = useTheme();
  const {currentLanguage, defaultLanguage} = useLanguageStore();

  const questionText = getTranslatedText(domanda, domandaTranslations, currentLanguage, defaultLanguage);
  const questionDescriptionText = domandaDescription ? getTranslatedText(domandaDescription, domandaDescriptionTranslations, currentLanguage, defaultLanguage) : null;

  return (
    <Container sx={{height: '40%'}}>
      <Box sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <Textfit mode={'multi'} min={15} max={40}
                 style={{
                   color: tipo === 'color' ? (theme.palette.getContrastText(colore || pleshDark.palette.background.paper)) : theme.palette.text,
                   width: '100%',
                   height: '80%',
                   textAlign: 'center',
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'center',
                   paddingTop: '2.5rem',
                   whiteSpace: 'pre-line',
                 }}>
          {questionText}
        </Textfit>
        {questionDescriptionText &&
          <Typography
            variant='body1'
            fontWeight={'lighter'}
            whiteSpace='pre-line'
          >
            {questionDescriptionText}
        </Typography>}
      </Box>
    </Container>
  )
}

function QuestionContent({elementPlaying, theme}) {
  return (
    <Container sx={{height: '75%', position: 'relative', paddingTop: '20px', textAlign: 'center'}}>
      <QuestionSwitch elementPlaying={elementPlaying} theme={theme}/>
    </Container>
  )
}

export default function QuestionDialogContent({url, user, idPlaying, open, theme}) {
  const [elementPlaying, setElementPlaying] = useState({})

  useEffect(() => {
    if (idPlaying) {
      const unsubscribe = firestore.collection(url + '/queue').doc(idPlaying).onSnapshot(s => {
        setElementPlaying({...s.data(), id: s.id})
      });

      return () => unsubscribe();
    }
  }, [idPlaying, url])
  return (
    <Stack id={'questionDialogBg'} justifyContent={"space-between"} style={{height: '100%', zIndex: 1}}>
      <QuestionBar
        idPlaying={idPlaying}
        tipo={elementPlaying.tipo}
        colore={elementPlaying.colore}
        domanda={elementPlaying.domanda}
        domandaTranslations={elementPlaying.domandaTranslations}
        domandaDescription={elementPlaying.domandaDescription}
        domandaDescriptionTranslations={elementPlaying.domandaDescriptionTranslations}
      />
      <QuestionContent elementPlaying={elementPlaying} user={user} theme={theme}/>
    </Stack>
  )
}
